export default "__VITE_ASSET__DejlD8Ny__"